export enum FeedbackFormEvents {
  FullTimeHRHub = 'FullTimeHRHub',
  OfficeHoursLinux = 'OfficeHoursLinux',
  OfficeHours = 'OfficeHours',
}

export const shouldShowFeedbackForEvent = (eventTags?: string[]): boolean => {
  if (!eventTags || eventTags.length === 0) {
    return false;
  }

  return Object.values(FeedbackFormEvents).some((allowedTag) =>
    eventTags.some(
      (tag) => tag.toLowerCase().trim() === allowedTag.toLowerCase().trim(),
    ),
  );
};
